import {ProviderEditComponent} from './provider-edit/provider-edit.component';
import {InvoiceModule} from '../../invoicing/invoice/invoice.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProviderComponent } from './provider.component';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { ComponentsModule } from '../../../components/components.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import {ConfirmPopupModule} from 'primeng/confirmpopup';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { PipesModule } from '../../../pipes/pipes.module';
import { MenuModule } from 'primeng/menu';
import { DialogModule } from 'primeng/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { SelectModule } from 'primeng/select';
import { InputNumberModule } from 'primeng/inputnumber';


@NgModule({
  declarations: [ProviderComponent, ProviderEditComponent],
  imports: [
    CommonModule,
    ComponentsModule,
    PanelModule,
    ButtonModule,
    TableModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    InvoiceModule,
    InputTextModule,
    ConfirmDialogModule,
    ToastModule,
    PipesModule,
    MenuModule,
    DialogModule,
      DialogModule,
      SelectModule,
    TranslateModule,
    InputNumberModule
  ],
  exports: [ProviderComponent]
})
export class ProviderModule { }
